/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChiusuraCompensoCreateDTO
 */
export interface ChiusuraCompensoCreateDTO {
    /**
     * 
     * @type {number}
     * @memberof ChiusuraCompensoCreateDTO
     */
    sequenza?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ChiusuraCompensoCreateDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChiusuraCompensoCreateDTO
     */
    importo?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChiusuraCompensoCreateDTO
     */
    bold?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChiusuraCompensoCreateDTO
     */
    color?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChiusuraCompensoCreateDTO
     */
    esclusoDaTotale?: boolean;
}

/**
 * Check if a given object implements the ChiusuraCompensoCreateDTO interface.
 */
export function instanceOfChiusuraCompensoCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChiusuraCompensoCreateDTOFromJSON(json: any): ChiusuraCompensoCreateDTO {
    return ChiusuraCompensoCreateDTOFromJSONTyped(json, false);
}

export function ChiusuraCompensoCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChiusuraCompensoCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sequenza': !exists(json, 'sequenza') ? undefined : json['sequenza'],
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
        'importo': !exists(json, 'importo') ? undefined : json['importo'],
        'bold': !exists(json, 'bold') ? undefined : json['bold'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'esclusoDaTotale': !exists(json, 'esclusoDaTotale') ? undefined : json['esclusoDaTotale'],
    };
}

export function ChiusuraCompensoCreateDTOToJSON(value?: ChiusuraCompensoCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sequenza': value.sequenza,
        'descrizione': value.descrizione,
        'importo': value.importo,
        'bold': value.bold,
        'color': value.color,
        'esclusoDaTotale': value.esclusoDaTotale,
    };
}

